import React, { Component } from "react";
import { PopularProducts } from "../components/Products/PopularProducts";
import dynamicPortal from "../utils/dynamicPortal";

export class PopularProductsPortal extends Component {
  render() {
    return dynamicPortal.load(".js-react-popular-products", (config) => {
      return <PopularProducts config={config} />;
    });
  }
}

export default PopularProductsPortal;



// WEBPACK FOOTER //
// ./src/portals/PopularProductsPortal.js